import { render, staticRenderFns } from "./ProceedingsSearch.vue?vue&type=template&id=2df51d00&"
import script from "./ProceedingsSearch.vue?vue&type=script&lang=js&"
export * from "./ProceedingsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports